import "./StatusPlaceholder.css";
import type { ComponentProps } from "react";

interface StatusPlaceholderProps extends ComponentProps<"div"> {
	label: string;
	sublabel: string;
	image: SVGFC;
}

export function StatusPlaceholder(props: StatusPlaceholderProps) {
	const { image: Image, label, sublabel, ...rest } = props;
	return (
		<div className="status-placeholder">
			<Image />
			<div className="labels">
				<div>{label}</div>
				<div>{sublabel}</div>
			</div>
			<div {...rest}>{props.children}</div>
		</div>
	);
}
